<template>
  <div>
    <div class="footer-wrap">
      <div class="container pt-5 pb-4">
        <!-- <h5 class="mb-4">
          Back
        </h5> -->
        <ul class="info-list">
          <!-- Copyright -->
          <li>
            <div id="copyright">
              <h2 class="mb-4 pb-3"><b> Copyright Information</b></h2>
              <h3 class="mb-2 pb-1">
                <b class="">
                  Copyright &copy; [Your store name] [Year]. All rights
                  reserved.
                </b>
              </h3>
              <p>
                All content on this site—including product images, text,
                graphics, logos, and digital downloads—is owned by GoEnroll123
                or licensed to us. This material is protected by copyright and
                intellectual property laws. Any use, reproduction, or
                distribution without written consent is prohibited.
              </p>
            </div>
          </li>
          <li>
            <!-- privacy statement -->
            <div class="mt-5" id="privacy">
              <h2 class="mb-4 pb-3"><b> Privacy Statements</b></h2>
              <div class="mb-2 pb-1">
                <h3 class=""><b>Your data, protected.</b></h3>
              </div>
              <p>
                GoEnroll123 collects personal and billing information to process
                orders, deliver products, and provide customer support. We value
                your trust and protect your data using secure technologies.
              </p>

              <h3 class="mb-2 pb-1"><b class=""> What we collect:</b></h3>
              <ul class="info-sub-list">
                <li>Name, email, phone number</li>
                <li>Shipping and billing address</li>
                <li>Payment details (processed securely)</li>
                <li>Order history</li>
                <li>
                  Browser and device data (for analytics and fraud prevention)
                </li>
              </ul>

              <h3 class="mb-2 pb-1 mt-3">
                <b class=""> How we use it:</b>
              </h3>
              <ul class="info-sub-list">
                <li>To process and fulfill your orders</li>
                <li>To communicate order updates and support</li>
                <li>To personalize your experience and improve the site</li>
                <li>To prevent fraud and ensure security</li>
              </ul>
              <p>
                We never sell your personal information. Payment details are
                encrypted and handled by PCI-compliant services. You can request
                to view, modify, or delete your data by contacting
                <a href="mailto:info@corenroll.com" class="mail-send"
                  ><b>[info@corenroll.com]</b></a
                >
              </p>
            </div>
          </li>
          <li>
            <!-- Disclaimers -->
            <div class="mt-5" id="disclaimers">
              <h2 class="mb-4 pb-3"><b> Disclaimers</b></h2>
              <h3 class="mb-2 pb-1">
                <b class=""> We do our best—but no guarantees.</b>
              </h3>
              <p>
                All product information, pricing, and availability on this site
                are provided “as is” and subject to change without notice. We
                aim for accuracy but don’t guarantee that all details are
                current or error-free.
              </p>
              <p>
                GoEnroll123 is not liable for delays, inaccuracies, or losses
                caused by use of the website, shipping issues, or third-party
                services. Links to other sites are not endorsements. Use them at
                your own discretion.
              </p>
            </div>
          </li>

          <li>
            <!-- terms and condition -->
            <div class="mt-5" id="terms">
              <h2 class="mb-4 pb-3"><b> Terms and Conditions</b></h2>
              <h3 class="mb-2 pb-1">
                <b class="">
                  Using our site means you agree to the following terms:</b
                >
              </h3>
              <ul class="info-sub-list">
                <li>
                  You must provide accurate personal and billing info to place
                  an order.
                </li>
                <li>
                  All content on this site is property of GoEnroll123 and cannot
                  be reused without permission.
                </li>
                <li>
                  Orders are subject to availability and confirmation of
                  payment.
                </li>
                <li>
                  We reserve the right to refuse service, cancel orders, or
                  limit quantities.
                </li>
                <li>
                  You agree not to engage in any fraudulent or illegal activity
                  on our site.
                </li>
              </ul>
              <p class="mt-2 pt-1">
                <b> Refunds, returns, and shipping policies </b>are detailed
                [link to relevant page]. These terms are governed by the laws of
                [Your Jurisdiction]. Continued use of this site means you accept
                these terms, including any updates.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
</script>
<script>
export default {
  name: "FooterContent",
  methods: {
    goToSection(page, sectionId) {
      if (this.$route.path !== page) {
        window.open(`${this.$route.path}#${sectionId}`, "_blank");
        this.$router.push({ path: page, hash: `#${sectionId}` }).then(() => {
          this.scrollToSection(sectionId);
        });
      } else {
        this.scrollToSection(sectionId);
      }
    },
    scrollToSection(sectionId) {
      this.$nextTick(() => {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      });
    },
  },
};
</script>
<style>
</style>